import React, { Component } from 'react';
import './style.scss'
import Rooms from './Rooms';
import Students from './Students';

class RoomsAndStudents extends Component {
  render() {
    return (
      <div className="qbm-content RoomsAndStudents">
        <Rooms />
        <Students />
      </div>
    );
  }
}

export default RoomsAndStudents;



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/RoomsAndStudents/index.jsx